"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const watchers = new Map();
function watch(node, callback) {
    if (!node) {
        return;
    }
    document.fonts.ready.then(callback);
    const mo = new MutationObserver(callback);
    mo.observe(node, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true,
    });
    watchers.set(node, mo);
}
function unwatch(node) {
    const mo = watchers.get(node);
    if (!mo) {
        return;
    }
    mo.disconnect();
    watchers.delete(node);
}
exports.default = {
    watch,
    unwatch,
};
